import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var ExternalIdentifierTypeDtoNameInline;
(function (ExternalIdentifierTypeDtoNameInline) {
    ExternalIdentifierTypeDtoNameInline["INT64"] = "INT64";
})(ExternalIdentifierTypeDtoNameInline || (ExternalIdentifierTypeDtoNameInline = {}));
export var CreateDocumentFormDocumentTypeInline;
(function (CreateDocumentFormDocumentTypeInline) {
    CreateDocumentFormDocumentTypeInline["DPA"] = "DPA";
})(CreateDocumentFormDocumentTypeInline || (CreateDocumentFormDocumentTypeInline = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var PostAccountRole;
(function (PostAccountRole) {
    PostAccountRole["ADVERTISER"] = "ADVERTISER";
    PostAccountRole["BROKER"] = "BROKER";
    PostAccountRole["AGENCY"] = "AGENCY";
})(PostAccountRole || (PostAccountRole = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["YEARLY_DISCOUNT"] = "YEARLY_DISCOUNT";
})(DiscountType || (DiscountType = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var EmailAddressType;
(function (EmailAddressType) {
    EmailAddressType["INVOICE"] = "INVOICE";
    EmailAddressType["SUGGESTION"] = "SUGGESTION";
})(EmailAddressType || (EmailAddressType = {}));
export var PostContactRole;
(function (PostContactRole) {
    PostContactRole["CEO"] = "CEO";
    PostContactRole["SALES"] = "SALES";
    PostContactRole["OPERATION"] = "OPERATION";
    PostContactRole["CUSTOMER"] = "CUSTOMER";
})(PostContactRole || (PostContactRole = {}));
